module.exports = __webpack_public_path__ + "img/monthly-budget-planner_B09QP6QP6G.80204297.jpg";